import { render, staticRenderFns } from "./BizOperationYearReport2022.vue?vue&type=template&id=139d02f5&"
import script from "./BizOperationYearReport2022.vue?vue&type=script&lang=js&"
export * from "./BizOperationYearReport2022.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports